
import api from "./api";

const VehicleReportService = {

  getSearch: async (params) => {
    const response = await api.get("/vehicleReport/getSearch", {
      params: {
        companyId: params.companyId,
        projectId: params.projectId,
        vehicleId: params.vehicleId,
        readingDate: params.readingDate,
        page: params.page,
        limit: params.limit
      }
    });
    return response.data;
  }
  ,

  getVehicleReadingReport: async ({
    pageNumber,
    noofRows,
    companyId,
    employeeId,
    roleId,
    company,
    project,
    vehicleName,
    vehicleNumber,
    vehicleType,
    vendorName,
    fromDate,
    toDate
  }) => {
    try {
      const res = await api.get("/vehicleReport/getReadingReport", {
        params: {
          pageNumber,
          noofRows,
          companyId,
          employeeId,
          roleId,
          company,
          project,
          vehicleName,
          vehicleNumber,
          vehicleType,
          vendorName,
          fromDate,
          toDate
        }
      });

      return res.data; // { status, result }
    } catch (err) {
      console.error("Inventory projects error", err);
      return { status: false, result: [] };
    }
  },

  getVehicleReadingReportDetails: async ({
    vehicleId,
    projectId,
    companyId,
    fromDate,
    toDate
  }) => {
    try {
      const res = await api.get("/vehicleReport/getReadingReportDetails", {
        params: {
          vehicleId,
          projectId,
          companyId,
          fromDate,
          toDate
        }
      });

      return res.data;
    } catch (err) {
      console.error("Report Details Error", err);
      return { status: false };
    }
  }
};
export default VehicleReportService;